import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/turivana/frontend/node_modules/next-intl/dist/esm/production/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/var/www/turivana/frontend/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["ExperiencePage"] */ "/var/www/turivana/frontend/src/components/ExperiencePage.tsx");
